import { BdaDataset } from "./BdaDataset";
import { BdaModel } from "./BdaModel";
import { Datasource } from "./Datasource";
import { Workflow, WorkflowMode } from "./Workflow";
import { AccessLevel, ExecutionStatus } from "./generics";
import { Organization, Owner } from "./ControlPanel";

export class BdaApplication {
  accessLevel: AccessLevel;
  createDateTime?: string;
  datasets?: BdaDataset[];
  defaultDatasource?: number | Datasource;
  defaultVersion?: boolean;
  description: string;
  fatherId?: number;
  id?: number;
  metadata: any;
  mlFlowUrl?: string;
  models?: BdaModel[];
  name: string;
  organization?: Organization;
  owner?: Owner;
  status?: ExecutionStatus;
  tags: string[];
  updateDateTime?: string;
  version?: number;
  versions?: ApplicationVersion[];
  vizConfigurations?: any[];
  workflows: Workflow[];
  workflowMode?: WorkflowMode;
  datasetCount?: number;
  modelCount?: number;
  serviceCount?: number;
  default?: boolean;
  notes?: Note[];
  template?: boolean;

  constructor(application?: BdaApplication) {
    this.name = application?.name || '';
    this.description = application?.description || '';
    this.accessLevel = application?.accessLevel || AccessLevel.TEAM;
    this.tags = application?.tags || [];
    this.workflows = [
      {
        procedure: application?.workflows[0].procedure || [],
        translation: application?.workflows[0].translation || null,
        targetPlatform: application?.workflows[0].targetPlatform || 'K8S',
        mode: application?.workflows[0].mode || WorkflowMode.BATCH,
        services: application?.workflows[0].services || [],
      }
    ];
  }
}

export interface ApplicationVersion {
  bdaId: number;
  createdBy: Owner;
  createdDate: string;
  defaultVersion: boolean;
  version: number;
}

export interface Annotation {
  key?: string;
  name?: string;
  suggestion?: string;
  value?: string;
  values?: Annotation[];
}

export interface Note {
  path: string;
  suggestion: string;
  personalNotes?: string;
  json?: string;
}

export interface ExternalServiceItem {
  annotations: string[];
}